import "./style.css";
import Accordion from "@/components/Accordion/accordion";

export default class TitleAndAccordion {
  static selector = ".title-and-accordion";

  constructor(block) {
    this.block = block;
    this.accordion = this.block.querySelector("#service-accordion");
    new Accordion(this.accordion, { scrollTopBlock: 'nearest', scrollTopItem: 'current' });
  }

  // Public methods
  onResize() {}
  onScroll() {}
}
